export const HOSTNAME_INPUT_PATTERN =
  "^((https?)://)?(www.)?([a-z0-9-]+.[a-z]+.[a-z]+|[a-z0-9-]+.[a-z]+)(/[a-zA-Z0-9#]+/?)*[/]?$";
